// ─── Region / Sub-region config ───────────────────────────────────────────────
// Edit the maps below to change how market_area (and segment_sales for AMER US)
// drive the region and sub_region fields on every deal.
//
// sub_region: null  →  the sub_region is resolved from segment_sales instead
//                       (used for United States where segment drives the split).

export interface RegionEntry {
  region: string;
  sub_region: string | null;
}

export const MARKET_AREA_REGION_MAP: Record<string, RegionEntry> = {
  // ── AMER ────────────────────────────────────────────────────────────────────
  'United States':        { region: 'AMER', sub_region: null },   // → resolved via segment_sales
  'Canada':               { region: 'AMER', sub_region: 'Canada' },
  'Strat. Latin America': { region: 'AMER', sub_region: 'LATAM' },
  'Brazil':               { region: 'AMER', sub_region: 'LATAM' },
  'Mexico':               { region: 'AMER', sub_region: 'LATAM' },

  // ── EMEA ────────────────────────────────────────────────────────────────────
  'United Kingdom': { region: 'EMEA', sub_region: 'UKI' },
  'SSA & Israel':   { region: 'EMEA', sub_region: 'MEA' },
  'Middle East':    { region: 'EMEA', sub_region: 'MEA' },
  'Italy':          { region: 'EMEA', sub_region: 'CENTRAL' },
  'Nordic':         { region: 'EMEA', sub_region: 'CENTRAL' },
  'Germany':        { region: 'EMEA', sub_region: 'CENTRAL' },
  'France':         { region: 'EMEA', sub_region: 'CENTRAL' },
  'Switzerland':    { region: 'EMEA', sub_region: 'CENTRAL' },
  'Iberica':        { region: 'EMEA', sub_region: 'OTHERS' },
  'Benelux':        { region: 'EMEA', sub_region: 'OTHERS' },
  'Easterm Europe': { region: 'EMEA', sub_region: 'OTHERS' },

  // ── JAPAC ───────────────────────────────────────────────────────────────────
  'India':  { region: 'JAPAC', sub_region: 'OTHERS' },
  'ANZ':    { region: 'JAPAC', sub_region: 'ANZ' },
  'Japan':  { region: 'JAPAC', sub_region: 'JAPAN' },
  'SEA':    { region: 'JAPAC', sub_region: 'SEA' },
  'Korea':  { region: 'JAPAC', sub_region: 'OTHERS' },
};

// Segment → sub_region for AMER deals where sub_region is null (i.e. United States).
export const AMER_SEGMENT_SUBREGION: Record<string, string> = {
  'Industry':   'IND',
  'Enterprise': 'ENT',
  'Scale':      'SCALE'
};

export const AMER_SEGMENT_SUBREGION_DEFAULT = 'Others';

export function resolveRegion(
  market_area: string | undefined,
  segment_sales: string | undefined
): { region: string; sub_region: string } | null {
  if (!market_area) return null;
  const entry = MARKET_AREA_REGION_MAP[market_area];
  if (!entry) return null;

  const sub_region =
    entry.sub_region ??
    AMER_SEGMENT_SUBREGION[segment_sales ?? ''] ??
    AMER_SEGMENT_SUBREGION_DEFAULT;

  return { region: entry.region, sub_region };
}
